import Lookup from 'src/componentes/select2';

const TipoValorDesatualizadoLookup = (props) => {
  return (
    <Lookup
      showSearch={false}
      labelKey="descricao"
      valueKey="id"
      url="/TipoValorDesatualizadoLookup"
      clearable={true}
      {...props}
    />
  );
};

export default TipoValorDesatualizadoLookup;
